import { render, staticRenderFns } from "./masthead-alt.vue?vue&type=template&id=4a013730&scoped=true&"
import script from "./masthead-alt.vue?vue&type=script&lang=js&"
export * from "./masthead-alt.vue?vue&type=script&lang=js&"
import style0 from "./masthead-alt.vue?vue&type=style&index=0&id=4a013730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a013730",
  null
  
)

export default component.exports